import React, { useEffect, useRef, useState } from 'react';
import { Stack, TextField, Grid, Autocomplete } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import "../../../sections/auth/login/login.css"
import { toast, ToastContainer } from 'react-toastify';
import { postData, validatePostData } from 'src/webService/webService';
import { Link, useLocation, useParams } from 'react-router-dom';
import loader from '../../../components/icons/loads.gif';
import Iconify from 'src/components/iconify';

export default function PasswordResetForm() {
    const [userInput, setUserInput] = useState('');
    
    const [isLoading, setIsLoading] = useState(false);
    const [loaderLabel, setLoaderLabel] = useState('');
    
    const location = useLocation();
    const { token } = useParams();
    const [isResetReqSent, setIsResetReqSent] = useState(false);
    const [isPasswordChange, setIsPasswordChange] = useState(false);
    const [isPasswordChangeValid, setIsPasswordChangeValid] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [isPasswordResetDone, setIsPasswordResetDone] = useState(false);
  
    useEffect(() => {
      const path = location.pathname.substring(1);
      setIsPasswordChange(path.startsWith('seller-password-reset'));

      if(path.startsWith('seller-password-reset')){
          postData("auth/seller/validate/reset/"+token, [], null).then((res) => {
              if(res.activeStatus == true) {
                    setIsPasswordChangeValid(true);
                } else {
                    setIsPasswordChangeValid(false);
                }
          });
      }
    }, [location.pathname]);

    const handleSendRequest = (e, status) => {
        setLoaderLabel('Login Verifying');
        setIsLoading(true);
        e.preventDefault();

        if (userInput === '') {
            toast.error("Username or email id is required");
            setIsLoading(false);
        } else {
            validatePostData("auth/seller/password/reset", {user:userInput}, null)
                .then((res) => {
                    switch (res.status) {
                        case 200:
                            setIsResetReqSent(true);
                            break;
                        case 404:
                            toast.error("User not found");
                            break;
                        default:
                            toast.error("Cant able to proceed right now. Please try again");
                            break;
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                    toast.error("Cant able to proceed right now. Please try again");
                });
            setIsLoading(false);
        }
    }

    const handleConfirmRequest = (e, status) => {
        setLoaderLabel('Loading');
        setIsLoading(true);
        e.preventDefault();

        if (newPassword != '' && confirmNewPassword != '' && newPassword == confirmNewPassword) {
            validatePostData("auth/seller/confirm/reset/"+token, {password:newPassword}, null)
                .then((res) => {
                    switch (res.status) {
                        case 200:
                            setIsPasswordResetDone(true);
                            break;
                        case 404:
                            toast.error("User not found");
                            break;
                        case 410:
                            toast.error("Invalid request");
                            break;
                        default:
                            toast.error("Cant able to proceed right now. Please try again");
                            break;
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                    toast.error("Cant able to proceed right now. Please try again");
                });
            setIsLoading(false);
        } else {
            toast.error("Password and Confirm password must be filled and match");
            setIsLoading(false);
        }
    }

    return (
        <>
            <ToastContainer position='top-right' />
            {(isPasswordChange) ?
            <Stack spacing={3}>
                <div style={{ position: 'relative' }}>
                    <h4 className='text-center'>{(isPasswordChangeValid)?'Change password':'Link Expired'}</h4>
                </div>
                {(isPasswordChangeValid)?
                ((!isPasswordResetDone)?<Grid container>
                        <Grid item xs={12} className='mt-3'>
                            <TextField
                                type="password"
                                className="w-100"
                                name="New Password"
                                label="New Password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                autoComplete="off"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} className='mt-3'>
                            <TextField
                                type="password"
                                className="w-100"
                                name="Confirm New Password"
                                label="Confirm New Password"
                                value={confirmNewPassword}
                                onChange={(e) => setConfirmNewPassword(e.target.value)}
                                autoComplete="off"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} className='mt-3'>
                            {isLoading ? GetLoader() :(
                                <LoadingButton fullWidth size="large" type="submit" variant="contained" sx={{ my: 2 }} onClick={handleConfirmRequest}>Update Password</LoadingButton>
                            )}
                        </Grid>
                </Grid>:
                <Grid container>
                    <Grid item xs={12} className='mt-1 mb-5'>
                        <p className='text-center'>Password resetted successfully. Kindly login to procced to your account</p>
                        <a href='/seller/login'><LoadingButton variant="contained" sx={{ my: 2 }}>Login</LoadingButton></a>
                    </Grid>
                </Grid>)
                :
                <Grid container>
                    <Grid item xs={12} className='mt-1 mb-5'>
                        <p className='text-center'>Please contact support for any assistance</p>
                    </Grid>
                </Grid>
                }
            </Stack> :
            <Stack spacing={3}>
                <div style={{ position: 'relative' }}>
                    <h4 className='text-center'>Password Reset</h4>
                </div>
                {(!isResetReqSent)?<Grid container>
                        <Grid item xs={12} className='mt-3'>
                            <TextField
                                className="w-100"
                                name="userInput"
                                label="Username or Email"
                                value={userInput}
                                onChange={(e) => setUserInput(e.target.value)}
                                autoComplete="off"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} className='mt-3'>
                            {isLoading ? GetLoader() :(
                                <LoadingButton fullWidth size="large" type="submit" variant="contained" sx={{ my: 2 }} onClick={handleSendRequest}>Send request</LoadingButton>
                            )}
                        </Grid>
                </Grid>:<p className='mb-5 text-center'>We’ve sent a password reset link to your email. Please check your inbox to continue.</p>}
            </Stack>
            }

            <Link className="nav-link text-center" to="/home">
                <Iconify icon="eva:arrow-circle-left-outline" sx={{ mr: 1 }} />  Back to home
            </Link>
        </>
    );

    function GetLoader() {
        return <>
            <div className='d-flex' style={{ textAlign: 'center', padding: '20px' }}>
                <img width='10%' src={loader} alt="Loading..." />
                {loaderLabel}
            </div>
        </>
    }
}